import * as types from "./actionTypes";

export function throwException(exception) {
	return {
		type: types.THROW_EXCEPTION,
		body: exception
	};
}

export function clearException(exception) {
	return {
		type: types.CLEAR_EXCEPTION
	};
}
